export class ResponseReglamentoInterno{
    payload:ReglamentoInternoModel;

    constructor(){
        this.payload = new ReglamentoInternoModel();
    }
}


export class ReglamentoInternoModel{    
    id:number;
    jardinPeriodo:any;
    estructuraNiveles: EstructuraNiveles;
    mediosComunicacion:string;
    centroSaludParbulos:[CentroSaludParbulos];
    institucionDenuncia:InstitucionDenuncia;
    centroSaludCercano:[CentroSaludCercano];
    jardinExtraData:JardinExtraData;
    fechaElavoracion:Date;
    fechaActualizacion:Date;
    tipo:number;
    estado:number;
    constructor(){
        this.id = -1;
        this.tipo = -1;
        this.estado =-1;
       
    }
}


export class EstructuraNiveles{    
    id:number;
    numSalasSCMenor:number;
    edadSCMenor:number;
    observacionSCMenor:string;
    numSalasSCMayor:number;
    edadSCMayor:number;
    observacionSCMayor:string;
    numSalasSCHG:number;
    edadSCHG:number;
    observacionSCHG:string;
    numSalasMMenor:number;
    edadMMenor:number;
    observacionMMenor:string;
    numSalasMMayor:number;
    edadMMayor:number;
    observacionMMayor:string;
    numSalasMHG:number;
    edadMHG:number;
    observacionMHG:string;
    numSalasPNT:number;
    edadPNT:number;
    observacionPNT:string;
    numSalasSNT:number;
    edadSNT:number;
    observacionSNT:string;
    numSalasTHG:number;
    edadTHG:number;
    observacionTHG:string;
    numSalasMTHG:number;
    edadMTHG:number;
    observacionMTHG:string;
    constructor(){
        this.id = -1;
    }
}


export class InstitucionDenuncia{    
    id:number;
    direccionMP:string;
    comunaLocalidadMP:string;
    direccionCarab:string;
    comunaLocalidadCarab:string;
    direccionPDI:string;
    comunaLocalidadPDI:string;
    direccionTCP:string;
    comunaLocalidadTCP:string;

    constructor(){
        this.id = -1;
        this.direccionMP = "";
        this.comunaLocalidadMP = "";
        this.direccionCarab = "";
        this.comunaLocalidadCarab = "";
        this.direccionPDI = "";
        this.comunaLocalidadPDI = "";
        this.direccionTCP = "";
        this.comunaLocalidadTCP = "";
    }
}


export class CentroSaludParbulos{    
    id:number;
    idReglamentoInterno:number;
    centroSalud:string;
    direccion:string;
    comunaLocalidad:string;
    constructor(){
        this.id = -1;
        this.idReglamentoInterno = -1;
        this.centroSalud = "";
        this.direccion = "";
        this.comunaLocalidad = "";
    }
}

export class CentroSaludCercano{    
    id:number;
    idReglamentoInterno:number;
    nombre:string;
    direccion:string;
    telefono:string;
    constructor(){
        this.id = -1;
        this.idReglamentoInterno = -1;
        this.nombre = "";
        this.direccion = "";
        this.telefono = "";
    }
}

export class JardinExtraData{    
    idJardin:number;
    representanteLegal:string;
    telefonoFijo:string;
    movilInstitucional:string;
    directoraSubrogante:string;
    correoDirectoraSubrogante:string;
    telefonoFijoDirectoraSubrogante:string;
    movilInstitucionalDirectoraSubrogante:string;
    correoEstablecimientoDirectoraSubrogante:string;
    rroNumero:number;
    rroFecha:Date;
    rroRbd:number;

    constructor(){
        this.idJardin = -1;
        this.representanteLegal = "";
        this.telefonoFijo = "";
        this.movilInstitucional = "";
        this.directoraSubrogante = "";
        this.correoDirectoraSubrogante = "";
        this.telefonoFijoDirectoraSubrogante = "";
        this.movilInstitucionalDirectoraSubrogante = "";
        this.correoEstablecimientoDirectoraSubrogante = "";
    }
}
